// observatorio_react\src\routes\index.js
import React from "react";
import { Switch, Route } from "react-router-dom";

// Paginas
import {
  Analises,
  Contatos,
  DetalhesNoticia,
  Home,
  Noticias,
  Painel,
  Parceiros,
  Pesquisas,
  DeclaracaoDePrivacidade
} from "../pages";

// Rotas
function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/noticias" exact component={Noticias} />
      <Route path="/noticias/:id" exact component={DetalhesNoticia} />
      <Route path="/analises" component={Analises} />
      <Route path="/contato" component={Contatos} />
      <Route path="/parceiros" component={Parceiros} />
      <Route path="/paineis" exact component={Painel} />
      <Route path="/pesquisas" component={Pesquisas} />
      <Route path="/declaracao-de-privacidade" component={DeclaracaoDePrivacidade} />
      <Route path="*" component={Home} />
    </Switch>
  );
}

export default Routes;
